import { useCallback } from 'react';
import { useStore } from 'react-redux';
import type { RootState } from '@src/core/store';
import { useWidgetId } from '@src/core/IdProvider';
import { getFirstIncompleteEmbedSlot } from '../core/getFirstIncompleteEmbedSlot';
import { useProductBookingSequential } from './useProductBookingSequential';
import { useSlotBlockTitle } from './useSlotBlockTitle';

export const useGuardedAddToCartClick = (onValid?: () => void) => {
  const widgetId = useWidgetId();
  const store = useStore<RootState>();
  const seq = useProductBookingSequential();
  const slotBlockTitle = useSlotBlockTitle();

  return useCallback(() => {
    const block = getFirstIncompleteEmbedSlot(widgetId, store.getState());

    if (block) {
      seq.notifySequentialFeedback(block.highlightSlot, block.highlightSlot, slotBlockTitle(block.blockingSlot));
      return;
    }

    seq.clearSequentialUi();
    onValid?.();
  }, [widgetId, store, seq, slotBlockTitle, onValid]);
};
